import { render, staticRenderFns } from "./BookingSettings.vue?vue&type=template&id=8d20b7ba&"
import script from "./BookingSettings.vue?vue&type=script&lang=ts&"
export * from "./BookingSettings.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports